export default __webpack_public_path__ + "static/media/config.56c23722.svg";